import {useEffect, useState} from "react";

const THEME_KEY = "theme";
const THEME_EVENT = "themechange";

export type Theme = "dark" | "light";

export const getTheme = (): Theme => {
    const stored = window.localStorage.getItem(THEME_KEY);
    if (stored === "light" || stored === "dark") {
        return stored;
    }
    return "dark";
};

export const setTheme = (theme: Theme): void => {
    window.localStorage.setItem(THEME_KEY, theme);
    document.documentElement.setAttribute("data-theme", theme);
    window.dispatchEvent(new Event(THEME_EVENT));
};

export const useTheme = (): Theme => {
    const [theme, setThemeState] = useState<Theme>(getTheme);
    useEffect(() => {
        const handler = () => setThemeState(getTheme());
        window.addEventListener(THEME_EVENT, handler);
        return () => window.removeEventListener(THEME_EVENT, handler);
    }, []);
    return theme;
};

export const toggleTheme = (): Theme => {
    const current = getTheme();
    const next: Theme = current === "dark" ? "light" : "dark";
    setTheme(next);
    return next;
};

export const initTheme = (): void => {
    const theme = getTheme();
    document.documentElement.setAttribute("data-theme", theme);
};
